import { render, staticRenderFns } from "./SystemComponentCards.vue?vue&type=template&id=1f73c668&"
import script from "./SystemComponentCards.vue?vue&type=script&lang=js&"
export * from "./SystemComponentCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports